import { useEffect } from "react";

export default function useDocumentTitle(title) {
  useEffect(() => {
    document.title = "Intranet: " + title;
  }, [title]);
}
